'use client';

import Image from 'next/image';

// Utils
import { combineClasses } from '@shared/utils';

// Constants
import { FALLBACK_SRC } from '@shared/constants';

// Components
import { Badge } from '@shared/ui';
export interface ProfileCardProps {
  name: string;
  title?: string;
  avatar?: string;
  topics?: string[];
  className?: string;
  labelColor?: string;
  isShowTopic?: boolean;
  shouldShowExSupporters?: boolean;
}
const TrainingTopicsList = ({
  topics
}: {
  topics: string[];
}) => <div className="flex gap-2.5 flex-wrap" data-sentry-component="TrainingTopicsList" data-sentry-source-file="index.tsx">
    {topics.map((item, index) => <Badge key={`${item}-${index}`} label={item} variant="active" className="bg-slate-blue px-5 py-1.5 rounded-md h-min" labelClassName="text-white font-medium leading-[18px] text-wrap" />)}
  </div>;
export const ProfileCard = ({
  name = '',
  title = '',
  avatar,
  topics = [],
  className = '',
  labelColor = '',
  isShowTopic = false,
  shouldShowExSupporters = false
}: ProfileCardProps) => {
  return <div role="listitem" data-testid="profile-card" aria-label={`Profile card for ${name}`} className={combineClasses('w-full flex rounded-lg md:items-center flex-col md:flex-row gap-4', 'bg-frost-50 border-l-8', labelColor || 'border-l-label-100', isShowTopic ? 'min-h-[110px] p-5' : 'px-5 py-2.5', className)} data-sentry-component="ProfileCard" data-sentry-source-file="index.tsx">
      <div className={combineClasses('grid md:grid-cols-[300px_1fr] gap-4 items-center w-full', !isShowTopic && 'md:grid-cols-1')}>
        <div className="flex items-center gap-5">
          {/* Avatar */}
          <Image src={avatar || FALLBACK_SRC.AVATAR} alt={avatar ? `${name} avatar` : 'No avatar available'} width={50} height={50} data-testid={avatar ? 'profile-avatar' : 'profile-avatar-placeholder'} className="size-12.5 rounded-full flex-shrink-0 object-cover" data-sentry-element="Image" data-sentry-source-file="index.tsx" />

          {/* Name and title badge */}
          <div className={combineClasses('flex flex-col gap-1 max-w-employee-cert-item', 'text-xs leading-5 break-words w-max')}>
            <span aria-label="Profile name" data-testid="profile-name" className={combineClasses('text-frost-900 font-semibold text-pretty')}>
              {name}
            </span>

            {title && <span aria-label="Profile job title" data-testid="profile-title" className="w-fit text-3xs leading-5 text-frost-500 font-semibold">
                {title}
              </span>}
          </div>
        </div>

        {/* Training topics list (supporters/supportees) */}
        {isShowTopic && topics.length > 0 && <TrainingTopicsList topics={topics} />}
      </div>
      {shouldShowExSupporters && <div className={combineClasses('text-5xs font-semibold bg-frost-500 text-card', 'w-[110px] px-2 py-1.5 rounded')}>
          Ex-supporter
        </div>}
    </div>;
};